import { render } from "./TableHeader.vue?vue&type=template&id=9e8e3f4a"
import script from "./TableHeader.vue?vue&type=script&lang=js"
export * from "./TableHeader.vue?vue&type=script&lang=js"
script.render = render

export default script